export default __webpack_public_path__ + "static/media/spinningtools.294b579f.png";